import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50de8eea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-solution-second-block-wrap" }
const _hoisted_2 = { class: "terminal-solution-second-block" }

import {TabInteractiveBlock} from "@/features";
import {onBeforeMount, ref} from "vue";
import {big_card, conveyor, group, HelpModel, pay_card, useLocalizationStore} from "@/shared";
import {BlockCardItem, WrapTitle} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-solution-content-first-block',
  setup(__props) {

const {translate} = useLocalizationStore();

onBeforeMount(() => {
  initArrData();
});

const arrData = ref<Array<HelpModel>>(new Array<HelpModel>());

const initArrData = () => {
  arrData.value.push(new HelpModel({
    Text: "convenient_efficient_transactions",
    Image: pay_card,
  }));
  arrData.value.push(new HelpModel({
    Text: "avoid_long_queues",
    Image: group,
  }));
  arrData.value.push(new HelpModel({
    Text: "multiple_functions",
    Image: conveyor,
  }));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BlockCardItem), {
        image: _unref(big_card),
        text: _unref(translate)('terminal_solutions_page_first_card_text'),
        title: _unref(translate)('cash_in_cash_out_terminals'),
        class: "terminal-solution-second-block-block-card-item big left"
      }, null, 8, ["image", "text", "title"]),
      _createVNode(_unref(TabInteractiveBlock), {
        arrData: arrData.value,
        class: "terminal-solution-second-block-tab",
        color: "white"
      }, null, 8, ["arrData"])
    ])
  ]))
}
}

})